﻿import { mapGetters, mapState } from 'vuex';

export default {
    name: 'checklist-icon-success',
    template: '<svg role= "img" class="ts-symbol ts-symbol--tick ts-checklist__symbol ts-checklist__symbol--success" aria-hidden="true" > <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/UI/ECommerce/images/sprite/svg-symbols.svg#tick" /></svg>',
    props: ['width', 'height'],
}
